export function subscribe(context, eventName, listener) {
  const key = generateEventKey(context, eventName);
  EventsManager.addEvent(key, listener);
}

export function publish(context, eventName, data) {
  const key = generateEventKey(context, eventName);
  document.dispatchEvent(new CustomEvent(key, { detail: data }))
}

function generateEventKey(context, eventName) {
  return `${context}-${eventName}`;
}

class EventsManager {
  static events = {};

  static addEvent(eventName, callback) {
    if (this.events.hasOwnProperty(eventName)) {
      // remove listener
      document.removeEventListener(eventName, this.events[eventName]);
      delete this.events[eventName];
    }

    // add listener
    document.addEventListener(eventName, callback);
    this.events[eventName] = callback;
  }
}